import React from 'react';

function Footer_pt() {
  return (
    <div className="App">
        
        <section className="section-7">

            <footer className="page-footer font-small stylish-color-dark">

                <div className="container text-center text-md-left">
                    <div className="row">

                        <div className="col-lg-5 col-sm-12 mx-auto box-1">
                            <a href="index.html"><img src="images/footer-logo.png" alt="footer-logo" /></a>
                            <p>
                                Desenvolver soluções inteligentes que ajudam a melhorar a vida das pessoas, aprimorando diagnósticos e tratamentos médicos, oferecendo informações 
                                úteis para educadores e alunos, além de fornecer insights valiosos para empresas e governos. Por meio de suas pesquisas e inovações, o LINA tem 
                                como objetivo contribuir para um futuro mais inteligente e sustentável.
                            </p>
                        </div>
                        <hr className="clearfix w-100 d-md-none" />

                        <div className="col-lg-2 col-sm-4 box-2 mx-auto">

                     
                        <h5>Navegação</h5>

                            <ul class="list-unstyled">
                                <li>
                                    <a href="index.html">página principal</a>
                                </li>
                                <li>
                                    <a href="services.html">serviços</a>
                                </li>
                                <li>
                                    <a href="portfolio.html">portfolio</a>
                                </li>
                                <li>
                                    <a href="blog.html">Quem Somos</a>
                                </li>
                                <li>
                                    <a href="contact.html">contate-nos</a>
                                </li>
                                
                            </ul>

                      </div>

                      <hr className="clearfix w-100 d-md-none" />

                      <div className="col-lg-2 col-sm-4 box-3 mx-auto">

                          
                      <h5>Institucional</h5>

                        <ul class="list-unstyled">
                            <li>
                                <a href="http://www.ufpi.br" target="_blank" rel="noreferrer">UFPI</a>
                            </li>
                            <li>
                                <a href="https://www.ufpi.br/ccn" target="_blank" rel="noreferrer">CCN</a>
                            </li>
                            <li>
                                <a href="https://ppg2.ufpi.br/programa/?id=615" target="_blank" rel="noreferrer">PPgCC</a>
                            </li>
                            <li>
                                <a href="https://sigaa.ufma.br/sigaa/public/programa/apresentacao_stricto.jsf?lc=pt_BR&idPrograma=1453" target="_blank" rel="noreferrer">DCCMAPI</a>
                            </li>
                            <li>
                                <a href="http://www.fapepi.pi.gov.br/" target="_blank" rel="noreferrer">FAPEPI</a>
                            </li>
                        </ul>

                      </div>

                      <hr className="clearfix w-100 d-md-none" />

                      <div className="col-lg-2 col-sm-4 box-4 mx-auto">

                    
                      <h5>Acesso</h5>

                            <ul class="list-unstyled">
                                <li>
                                    <a href="https://www.gov.br/cnpq/pt-br" target="_blank" rel="noreferrer">CNPq </a>
                                </li>
                                <li>
                                    <a href="https://www.gov.br/capes/pt-br" target="_blank" rel="noreferrer">Capes</a>
                                </li>
                                <li>
                                    <a href="http://www.finep.gov.br/" target="_blank" rel="noreferrer">Finep </a>
                                </li>
                                <li>
                                    <a href="https://www.acm.org/" target="_blank" rel="noreferrer">ACM</a>
                                </li>
                                <li>
                                    <a href="https://www.ieee.org/" target="_blank" rel="noreferrer">IEEE </a>
                                </li>
                                
                            </ul>
                      </div>


                    </div>
                </div>

                <div className="footer-copyright text-center">
                  <div className="gradient"></div>
                  <p>© 2023, All Rights reserved. more theme, designed by<a href="https://www.template.net/editable/websites/html5"> tEMPLATE.net</a>
                  <br></br>Converted to React Native by <a href='http://lina.ufpi.br/vinicius' target={"_blank"} rel="noreferrer">Vinicius Machado</a></p>
              </div>

            </footer>

        </section>

    </div>
  );
}

export default Footer_pt;